import { Observable } from 'rxjs'
import { TrainingModel } from '../../user-management/models/training-model'
import { TrainingURLS } from '../models/trainingURLS'

export abstract class TrainingCertificatesGateway {
    abstract uploadFile(planyear: number, formData: FormData): Observable<Response>
    // abstract getImagesForPath(path: string): FileBrowserInfo[]
    abstract GetUserTrainingDetails(planyear: number): Observable<TrainingModel[]>
    abstract GetUserTrainingDetailsByPlanyear(planyear: number): Observable<TrainingModel[]>
    abstract GetNavigationURLs(): Observable<TrainingURLS>
    abstract LogintoCourseGuide(userName: string, planYear: number): Observable<string>
    abstract GetCurriculumCoursesByPlanyearAndOrgId(planyear: number, orgId: string): Observable<string[]>
    abstract ShowUploadCertificate(): Observable<boolean>
}
